import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { getGroup, getSubgroup, getMachines, setRowInReducer, setInitialState } from '../../../actions/resources/MachinesActions';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import AddMachines from './AddMachines';
import checkboxHOC from "react-table/lib/hoc/selectTable";
const CheckboxTable = checkboxHOC(ReactTable);
export class ViewMachines extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: this.props.add,
            edit: this.props.edit,
            showFilters: this.props.showFilters,
            selection: [],
            selectAll: false
        };
    }

    componentDidMount() {
        if (this.props.machinesGroupDropdown.length == 0) {
            this.props.getGroup();
        }
        if (this.props.machinesSubgroupDropdown.length == 0) {
            this.props.getSubgroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMachines(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');

        }
        if (nextProps.machinesPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.props.handleClose();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMachines(wrapped.state);
            this.props.setInitialState('machinesPostingSuccess');
        }
        this.setState({
            add: nextProps.add,
            showFilters: nextProps.showFilters,
            machine: nextProps.machine,
            machinesFetching: nextProps.machinesFetching,
            machinesGroupDropdown: immutable.asMutable(nextProps.machinesGroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            groupFetching: nextProps.groupFetching,
            groupFetchingFailed: nextProps.groupFetchingFailed,
            machinesSubgroupDropdown: immutable.asMutable(nextProps.machinesSubgroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            subgroupFetching: nextProps.subgroupFetching,
            subgroupFetchingFailed: nextProps.subgroupFetchingFailed,
        })
        if (nextProps.add == true && nextProps.edit == false) {
            this.props.setInitialState('machineObj');
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
        }

    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.machine.filter((machine) => {
                    return machine.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'machineObj');
            }
        });
        this.props.setSelection(selection, 'machine');
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
        this.props.setSelection(selection, 'machine');

    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };


    render() {
        let content;
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#ACDAF1" : "inherit"
                        }
                    };
                }
                return {};
            }
        };

        const columns = [
            {
                Header: i18n.t('Title'),
                accessor: 'naziv'
            },
            {
                Header: i18n.t('Code'),
                accessor: 'sifra',
                // Filter: ({filter, onChange }) =>
                //     <Select
                //         isMulti
                //         name="naziv"
                //         onChange={value => {
                //             onChange(value)
                //         }}
                //         closeMenuOnSelect={false}
                //         options={this.state.zones}
                //         className="multi-select-in-filter"
                //         classNamePrefix="select"
                //     />
            },
            {
                Header: i18n.t('Machine group name'),
                accessor: 'pogonska_masina_grupa_naziv',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.machinesGroupDropdown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Machine subgroup name'),
                accessor: 'pogonska_masina_podgrupa_naziv',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.machinesSubgroupDropdown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },

        ];
        content =
            <div className="page">
                <CheckboxTable data={this.props.machine}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    columns={columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    showPaginationTop
                    showPaginationBottom={false}
                    pages={this.props.machinesPages}
                    loading={this.props.machinesFetching}
                    manual
                    onFetchData={(state, instance) => this.props.getMachines(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddMachines add={this.state.add} edit={this.props.edit}
                    handleClose={this.props.handleClose} />}
            </div>


        return (
            <div>
                {content}
            </div>
        )
    }

};

function mapStateToProps(state) {
    return {
        machine: state.machinesReducer.machine,
        machinesFetching: state.machinesReducer.machinesFetching,
        machinesPages: state.machinesReducer.machinesPages,
        machinesGroupDropdown: state.machinesReducer.machinesGroupDropdown,
        groupFetching: state.machinesReducer.groupFetching,
        groupFetchingFailed: state.machinesReducer.groupFetchingFailed,
        machinesSubgroupDropdown: state.machinesReducer.machinesSubgroupDropdown,
        deleted: state.machinesReducer.deleted,
        machinesPostingSuccess: state.machinesReducer.machinesPostingSuccess,
        subgroupFetching: state.machinesReducer.subgroupFetching,
        subgroupFetchingFailed: state.machinesReducer.subgroupFetchingFailed,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
        getSubgroup: () => dispatch(getSubgroup()),
        getMachines: (state, instance) => dispatch(getMachines(state, instance)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewMachines)